import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function useCoach(coachId) {
  const [coach, setCoach] = useState(null);

  useEffect(() => {
    axios
      .get(routes.api.coaches.show(coachId))
      .then((response) => {
        setCoach(response.data.data);
      });
  }, [coachId]);

  return coach;
}
